<script setup lang="ts">
  interface Props {
    contentsId: string;
  }
  const props = defineProps<Props>();

  const getApiBaseURL = () => useRuntimeConfig().public.apiBaseUrl as string;
  const makeUrl = () => {
    return `${getApiBaseURL()}/contents/${props.contentsId}/download`;
  };
</script>

<template>
  <a class="download-button d-flex" :href="makeUrl()" download>
    <v-icon icon="$mdiDownload" size="x-large" color="white" />
  </a>
</template>
<style lang="scss" scoped>
  .download-button {
    cursor: pointer;
    border-radius: 15px;
    height: 30px;
    padding: 5px 12px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.8em;
    background-color: rgb(var(--v-theme-monochrome-03));
  }
  .disabled {
    cursor: not-allowed;
    color: rgb(var(--v-theme-monochrome-02));
  }
</style>
